import { useGlobalStoreShallow } from 'src/store/globalStore';

import { GlobalStyled } from '@components/_global/GlobalStyle/Global.styled';

export const GlobalStyledComponent = () => {
    const { blockScroll } = useGlobalStoreShallow(['blockScroll']);

    return <GlobalStyled blockScroll={blockScroll} />;
};
